import { Scheduler } from '../../components/scheduler/Scheduler.jsx'
import { getEvents, getVendorEvents } from '../../features/schedulerSlice.js'
import styles from './styles.module.css'
import { TimeLineProfileFilters } from './TimeLineProfileFilters.jsx'
import { getKazooMembers } from '../../features/kazooEventSlice.js'

import { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import VendorWeddingInfo from '../../components/VendorWeddingInfo/VendorWeddingInfo.jsx'
import { LeaveKazooPopup } from '../../components/popups/LeaveKazooPopup.jsx'
import ButtonCustom from '../../components/atoms/button/ButtonCustom.jsx'

export const VendorKazooInfoPage = ({ isStaff = false }) => {
	const dispatch = useDispatch()
	const { kazooId } = useParams()
	const timelineEvents = useSelector(
		(state) => state.scheduler.timelineEvents
	)
	const vendorTasks = useSelector((state) => state.scheduler.vendorTasks)
	const user = useSelector((state) => state.auth.user)
	const partyMembers = useSelector((state) => state.scheduler.selectedUsers)
	const isVendorStaff = isStaff || user.__t === 'vendor-staff'
	const [popupToggle, setPopupToggle] = useState(false)

	const togglePopup = () => setPopupToggle((prev) => !prev)

	useEffect(() => {
		dispatch(getEvents(kazooId)) // to display events
		if (!isVendorStaff) dispatch(getVendorEvents('isVendorTasks')) // to display tasks
		dispatch(getKazooMembers(kazooId))
	}, [dispatch, kazooId, isVendorStaff])

	const vendorKazooTasks = useMemo(
		() =>
			(vendorTasks || []).filter((task) => {
				const taskKazooId =
					task?.KazooDetails?.kazooId ||
					task?.KazooId ||
					task?.kazooId
				return taskKazooId && String(taskKazooId) === String(kazooId)
			}),
		[vendorTasks, kazooId]
	)

	const eventSettings = useMemo(() => {
		const source = [...(vendorKazooTasks || []), ...(timelineEvents || [])]
		const seen = new Set()
		const dataSource = source?.filter((item) => {
			if (!item._id || seen.has(String(item._id))) return false
			seen.add(String(item._id))
			return true
		})
		return {
			allowAdding: false,
			allowEditing: false,
			allowDeleting: false,
			allowResizing: false,
			allowDrag: false,
			dataSource,
		}
	}, [vendorKazooTasks, timelineEvents])

	return (
		<div style={{ padding: '12px 24px' }}>
			<VendorWeddingInfo kazooId={kazooId} />

			{!isVendorStaff && (
				<>
					<TimeLineProfileFilters />
					{popupToggle && (
						<LeaveKazooPopup
							popupToggle={popupToggle}
							userId={user._id}
							kazooId={kazooId}
							clickHandler={togglePopup}
						/>
					)}
					<div className={styles.schedulerWrap}>
						<div className="calendarWrp commonCalendar ">
							<div className="calendarInner">
								<Scheduler
									// editorTemplate={VendorTasksTemplate}
									// editorHeaderTemplate={VendorTasksTemplateHeader}
									// editorFooterTemplate={VendorTasksTemplateFooter}
									eventSettings={eventSettings}
									partyMembers={[
										...partyMembers,
										{
											Id: user._id,
											OwnerText: user.businessName,
										},
									]}
									allowDragAndDrop={false}
									allowResizing={false}
									height="77dvh"
								/>
							</div>
						</div>
					</div>
					<ButtonCustom onClick={togglePopup} data-cy="leave-wedding">
						Leave Wedding
					</ButtonCustom>
				</>
			)}
		</div>
	)
}
